import React, { useEffect, useState } from 'react';
import { MdMail, MdCall, MdLocationOn } from 'react-icons/md';
import { FaFacebook, FaTwitter, FaLinkedin, FaYoutube, FaInstagram, FaInstagramSquare } from 'react-icons/fa';
import companyLogo from './../image/whitebackground.png';
import { GiWorld } from "react-icons/gi";
import { Link, useNavigate } from 'react-router-dom';
import { GoMail } from "react-icons/go";
import { FaLinkedinIn } from "react-icons/fa";
import footer from "./../image/footer.png";
import { LuMail } from "react-icons/lu";
import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '../firebase.config';

const Footer = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, 'Service'));
        const fetchedServices = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setServices(fetchedServices);
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };

    fetchServices();
  }, []);
  const handleLoginClick = (e) => {
    e.preventDefault();

    const cachedAdmin = localStorage.getItem('admin');
    if (cachedAdmin) {
      navigate('/createItem');
    } else {
      navigate('/login');
    }
  };
  const handleServiceClick = (serviceId) => {
    navigate(`/service-details/${serviceId}`);
  };

  return (
    <footer className="bg-[#0b3155] text-white py-10 w-full relative"
    style={{
      backgroundImage: `url(${footer})`,
      backgroundSize: 'cover', // This will cover the entire area without repeating
      backgroundPosition: 'center', // This will center the image
      backgroundRepeat: 'no-repeat', // Prevent image repetition
    }}
    >
      <div className="container mx-auto px-4 max-w-[1400px] mb-5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          {/* Social Media Section */}
          <div className="flex flex-col lg:items-center items-start lg:text-center text-left lg:mb-0 mb-3">
            <img src={companyLogo} alt="Company Logo" className="w-40 md:w-40 mb-3" />
            <h4 className="text-md md:text-xl font-semibold mb-3">Connect with us</h4>
            <ul className="flex space-x-4">
              <li>
                <a href="https://www.linkedin.com/company/nexify-infosystems-llc" target="_blank" rel="noopener noreferrer">
                  <FaLinkedinIn className="text-2xl text-white hover:text-[#9fe2d8] transition duration-200" />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/nexify_infosystems?igsh=MXZkN3loYWtiYmVpdw==" target="_blank" rel="noopener noreferrer">
                  <FaInstagram className="text-2xl text-white hover:text-[#9fe2d8] transition duration-200" />
                </a>
              </li>
            </ul>
          </div>

          {/* About Us Section */}
          <div className="flex flex-col">
            <h4 className="text-md md:text-2xl font-semibold mb-3">About Us</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: 'Who We Are', path: '/about' },
                { label: 'Partners', path: '/partners' },
                { label: 'Career', path: '/consultantcareer' },
                { label: 'Blogs', path: '/Blogs' },
                { label: 'Contact Us', path: '/contact' },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-[13px] md:text-[16px] text-[#ffffffb3] hover:underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Section */}
          <div className="flex flex-col items-start lg:ml-[-140px]  ml-0 mr-0">
  <h4 className="text-md md:text-2xl font-semibold mb-3">Services</h4>
  <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
    {services.map((service) => (
      <li key={service.id} className="w-full">
        <button
          onClick={() => handleServiceClick(service.id)}
          className="text-[12px] md:text-[13px] lg:text-[15px] text-[#ffffffb3] hover:underline w-full text-left truncate overflow-hidden"
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,  // Ensures text wraps for 2 lines
            WebkitBoxOrient: 'vertical',
            whiteSpace: 'normal', // Allows text to wrap within two lines
          }}
        >
          {service.title}
        </button>
      </li>
    ))}
  </ul>
</div>

          {/* Contact Section */}
          <div className="flex flex-col">
            <h4 className="text-md md:text-2xl font-semibold mb-3">Contact Us</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-2 text-center">
                <MdCall className="text-[18px] text-white" />
                <a href="tel:7326129958" className="text-[13px] md:text-[16px] text-[#ffffffb3] hover:underline">
                  +1 732-612-9958
                </a>
              </li>
              <li className="flex items-center gap-2 text-center">
                <LuMail className="text-[18px] text-white" />
                <a href="mailto:info@nexifyinfosystems.com" className="text-[13px] md:text-[16px] text-[#ffffffb3] hover:underline">
                  info@nexifyinfosystems.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-center ">
                <LuMail className="text-[18px] text-white" />
                <a href="mailto:careers@Nexifyinfosystems.com" className="text-[13px] md:text-[16px] text-[#ffffffb3] hover:underline">
                  careers@Nexifyinfosystems.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-wrap justify-start gap-6 mt-4">
          <Link to="/privacy" className="text-xs md:text-sm font-semibold text-[#ffffffb3] hover:underline">
            Privacy
          </Link>
          <span className="text-[#ffffffb3]">|</span>
          <Link to="/terms" className="text-xs md:text-sm font-semibold text-[#ffffffb3] hover:underline">
            Terms
          </Link>
          <span className="text-[#ffffffb3]">|</span>
          <Link to="/cookie" className="text-xs md:text-sm font-semibold text-[#ffffffb3] hover:underline">
          Cookie 
          </Link>
          <span className="text-[#ffffffb3]">|</span>
          <Link
          onClick={handleLoginClick}
          to="#" className="text-xs md:text-sm font-semibold text-[#ffffffb3] hover:underline">
            Login
          </Link>
        </div>
      </div>

      <div className="absolute  py-4 text-left w-full border-t-2 border-[#4b4b4b] bottom-0"> {/* Adjusted bottom-0 */}
        <p className="text-xs md:text-sm font-semibold ml-16 text-[#ffffffb3]">&copy; {new Date().getFullYear()} Nexify Info System. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;